export interface Option {
	label: string;
	value: string;
	dataType?: string;
	/** When set, this string is inserted instead of `value` (e.g. function signature vs display name). */
	insertText?: string;
	/** Optional help text shown in UI (e.g. expression function descriptions from the API). */
	description?: string;
	/** Backend reaction type `name` (e.g. managerapprovalpopup); UI uses {@link label}. */
	reactionTypeApiName?: string;
	/** Advanced trigger API `triggerName`; used for formula `{token}` inserts. */
	triggerName?: string;
}

export const CATEGORY_BOOLEAN_VALUES = "Boolean Values";
export const CATEGORY_VARIABLES = "Variables";
export const CATEGORY_SCREEN_FIELDS = "Screen Fields";
export const CATEGORY_DATABASE_TABLES = "Database Tables";
export const CATEGORY_REACTIONS = "Reactions";

/** Node types never persisted (ghost placeholders, reaction anchor). */
export const UI_ONLY_NODE_TYPES = new Set(["reaction_location", "ghost"]);

/** Backend reaction type `name` for the free-response popup. */
export const FREE_RESPONSE_REACTION_TYPE_NAME = "freeresponsepopup";

export const isFreeResponseReactionType = (reactionTypeName: string | undefined): boolean =>
	reactionTypeName === FREE_RESPONSE_REACTION_TYPE_NAME;

/** Backend reaction type `name` for the user-confirmation popup. */
export const USER_CONFIRMATION_POPUP_REACTION_TYPE_NAME = "userconfirmationpopup";

export const isUserConfirmationPopupReactionType = (reactionTypeName: string | undefined): boolean =>
	reactionTypeName === USER_CONFIRMATION_POPUP_REACTION_TYPE_NAME;
